import { Alert, Button, Group, Title } from "@mantine/core";
import { getHotkeyHandler, useListState } from "@mantine/hooks";
import { IconAlertCircle } from "@tabler/icons-react";
import { ChangeEvent, useRef } from "react";
import MentionColaboradoresInput from "@/modules/colaboradores/components/mention-colaboradores-input";
import useIdeiaComentarioForm from "./useIdeiaComentarioForm";

const IdeiaComentarioForm = ({
  ideia,
  respostaAoComentario = null,
  onSuccess
}: {
  ideia: TIdeia;
  respostaAoComentario?: TIdeiaComentario | null;
  onSuccess?: () => void;
}) => {
  const [colaboraresMentioned, colaboradoresMentionedHandlers] = useListState<TColaborador["id"]>([]);
  const formReference = useRef<HTMLFormElement>(null);
  const { onSubmit, getInputProps, isPending, errors, values, setFieldValue } = useIdeiaComentarioForm({
    ideia,
    respostaAoComentario,
    onSuccess() {
      colaboradoresMentionedHandlers.setState([]);
      if (onSuccess) {
        onSuccess();
      }
    }
  });

  const genericError = errors[""];

  /**
   * Handle submit
   */
  function handleSubmit() {
    const formElement = formReference.current;
    if (formElement) {
      formElement.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
    }
  }

  /**
   * Handle change event from textarea
   * @param event - Change event from textarea
   */
  function handleChange(event: ChangeEvent<HTMLTextAreaElement>) {
    setFieldValue("comentario", event.target.value);
  }

  /**
   * Handle colaborador mentioned
   * @param id - ID of the user mentioned
   */
  function handleColaboradorMentioned(id: string) {
    setFieldValue("colaboradoresMencionadosReferences", [id, ...colaboraresMentioned]);
    colaboradoresMentionedHandlers.append(id);
  }

  return (
    <form onSubmit={onSubmit} ref={formReference}>
      <Title order={4} mb="md">
        Deixe um comentário sobre essa ideia
      </Title>

      <MentionColaboradoresInput
        {...getInputProps("comentario")}
        onKeyDown={getHotkeyHandler([["mod+Enter", handleSubmit]])}
        value={values.comentario}
        onChange={handleChange}
        data-autofocus
        placeholder="Escreva seu comentário aqui. Cmd/Ctrl + Enter para enviar"
        disabled={isPending}
        onColaboradorMentioned={handleColaboradorMentioned}
      />

      {genericError && (
        <Alert icon={<IconAlertCircle size="1rem" />} color="red" mb="md">
          {genericError}
        </Alert>
      )}
      <Group justify="flex-end" mr="sm">
        <Button type="submit" loading={isPending}>
          Enviar
        </Button>
      </Group>
    </form>
  );
};

export default IdeiaComentarioForm;
